export default "__VITE_ASSET__467db10a__"